import { render, staticRenderFns } from "./1_attention.vue?vue&type=template&id=3abad6ea&scoped=true&"
import script from "./1_attention.vue?vue&type=script&lang=js&"
export * from "./1_attention.vue?vue&type=script&lang=js&"
import style0 from "./1_attention.vue?vue&type=style&index=0&id=3abad6ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abad6ea",
  null
  
)

export default component.exports